import React, { useState, useEffect } from "react";
import {
  CheckCircle,
  ArrowRight,
  Settings,
  Zap,
  TrendingUp,
  AlertCircle,
  XCircle,
  RefreshCw,
} from "lucide-react";
import Content from "../../../Components/Dashboard/Content/Content";
import { User_Profile } from "../../../ReduxStore/Slice/Common/commoSlice";
import { useDispatch } from "react-redux";
import styles from "./Daynamiccss";
import {
  BrokerProfile_Info,
  DeltaBrokerProfile_Info,
  BinanceBrokerProfile_Info,
  ZebPayBrokerProfile_Info,
  Broker_Coinswitch_Wallet,
  BrokerPi42wallet_API
} from "../../../ReduxStore/Slice/BrokerSlice/BrokerSlice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";





const BROKER_CONFIG = {
  1: {
    name: "CoinDCX",
    action: BrokerProfile_Info,
    resultPath: (response) => response.data,
    guidePath: "/client/apicreateinfo/coinDCXGuide",
  },
  2: {
    name: "Delta Exchange",
    action: DeltaBrokerProfile_Info,
    resultPath: (response) => response?.data?.result,
    guidePath: "/client/apicreateinfo/Deltaexchange",
  },
  3: {
    name: "Binance",
    action: BinanceBrokerProfile_Info,
    resultPath: (response) => response.data,
    guidePath: "/client/apicreateinfo/BinanceGuide",
  },

  4: {
    name: "Zebpay",
    action: ZebPayBrokerProfile_Info,
    resultPath: (response) => response.data,
    guidePath: "/client/apicreateinfo/ZebpayGuide",
  },
  5: {
    name: "CoinSwitch",
    action: Broker_Coinswitch_Wallet,
    resultPath: (response) => response.data,
    guidePath: "/client/apicreateinfo/CoinSwitchGuide",
  },
  6: {
    name: "Pi42",
    action: BrokerPi42wallet_API,
    resultPath: (response) => response.data,
    guidePath: "/client/apicreateinfo/Pi42",
  },

};


const CONNECTION_STEPS = [
  { step: 1, title: "Select Broker", description: "Choose your trading platform" },
  { step: 2, title: "API Configuration", description: "Enter credentials" },
  { step: 3, title: "Testing", description: "Verify connection" },
  { step: 4, title: "Complete", description: "Ready to trade" },
];

const BrokerConnectPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const GoToDahboard_id = JSON.parse(localStorage.getItem("user_details_goTo"));


  const [userdetail, setUserdetail] = useState(null);
  const [brokerId, setBrokerId] = useState("");
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [connectionStep, setConnectionStep] = useState(1);
  const [apiCredentials, setApiCredentials] = useState({
    api_key: "",
    api_secret: "",
  });
  const [isConnecting, setIsConnecting] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [brokerdetail, setBrokerdetails] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchUserProfile();
  }, []);



  // Fetch user profile
  const fetchUserProfile = () => {
    const data = {
      id: gotodashboard ? GoToDahboard_id.user_id : user_details?.user_id,
    };

    dispatch(User_Profile(data))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setUserdetail(response.data[0]);
          setBrokerId(response.data[0]?.broker);
          setApiCredentials(response.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching user profile:", error);
      });
  };


  const getCurrentUserType = () => {
    return gotodashboard ? GoToDahboard_id.type : user_details?.type;
  };


  const getCurrentLicenseType = () => {
    return gotodashboard ? GoToDahboard_id.type : userdetail?.license_type;
  };



  const canConnectBroker = () => {
    const userType = getCurrentUserType();
    return userType !== 1 && userType !== "1";
  };


  const hasValidLicense = () => {
    const licenseType = getCurrentLicenseType();
    return licenseType === "0" || licenseType === "2";
  };


  const handleBrokerSelect = (broker) => {
    if (!canConnectBroker()) {
      Swal.fire({
        title: "Access Denied",
        text: "You do not have permission to connect a broker.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setSelectedBroker(broker);
    setConnectionStep(2);
    setConnectionStatus(null);
    setErrorMessage("");
  };




  const handleApiSubmit = async () => {
    setIsConnecting(true);
    setConnectionStep(3);

    const data = {
      _id: user_details?.user_id,
      api_secret: apiCredentials.api_secret,
      api_key: apiCredentials.api_key,
    };

    try {
      const brokerConfig = BROKER_CONFIG[brokerId] || BROKER_CONFIG[1];

      const response = await dispatch(brokerConfig.action(data)).unwrap();


      if (response?.status === true) {
        const brokerDetails = brokerConfig.resultPath(response);
        setBrokerdetails(brokerDetails);
        setConnectionStatus("success");
        setConnectionStep(4);
        setErrorMessage("");
        fetchUserProfile();

        Swal.fire({
          title: "Success!",
          text: "Broker connected successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        setTimeout(() => {
          window.location.reload();
        }, 4000);
      } else {
        handleConnectionError(response);
      }
    } catch (error) {
      handleConnectionError(error);
    } finally {
      setIsConnecting(false);
    }
  };



  const handleConnectionError = (error) => {
    setConnectionStatus("error");
    setConnectionStep(4);

    let errorMsg = "Connection failed. Please check your credentials.";

    if (error?.details?.error) {
      errorMsg = JSON.stringify(error.details.error);
    } else if (error?.data?.message) {
      errorMsg = error.data.message;
    } else if (error?.message) {
      errorMsg = error.message;
    } else if (error?.error) {
      errorMsg = JSON.stringify(error.error);
    }

    setErrorMessage(errorMsg);
  };


  const handleInputChange = (field, value) => {
    setApiCredentials((prev) => ({
      ...prev,
      [field]: value,
    }));
  };




  const resetProcess = () => {
    setSelectedBroker(null);
    setConnectionStep(1);
    setApiCredentials({ api_key: "", api_secret: "" });
    setConnectionStatus(null);
    setErrorMessage("");
  };



  const retryConnection = () => {
    setConnectionStep(2);
    setConnectionStatus(null);
    setErrorMessage("");
  };



  const navigateToGuide = () => {
    const brokerConfig = BROKER_CONFIG[userdetail?.broker];
    if (brokerConfig?.guidePath) {
      navigate(brokerConfig.guidePath);
    }
  };




  const getBrokerFields = () => {
    return styles.brokerFields[brokerId] || [];
  };




  const getFilteredBrokers = () => {

    return styles.BrokerArray.some((b) => b.id == userdetail?.broker)
      ? styles.BrokerArray.filter((broker) => broker?.id == userdetail?.broker)
      : styles.BrokerArray;
  };




  const renderProgressSteps = () => (
    <div className="progress-container" style={styles.progressContainerStyle}>
      <div className="progress-steps" style={styles.progressStepsStyle}>
        {CONNECTION_STEPS.map((step, index) => (
          <div key={step.step} style={styles.stepItemStyle}>
            <div
              className="step-circle"
              style={styles.stepCircleStyle(
                connectionStep >= step.step,
                connectionStep > step.step
              )}
            >
              {connectionStep > step.step ? (
                <CheckCircle style={{ width: "24px", height: "24px" }} />
              ) : (
                <span>{step.step}</span>
              )}
            </div>
            <div style={styles.stepInfoStyle} className="step-info">
              <p style={styles.stepTitleStyle(connectionStep >= step.step)}>
                {step.title}
              </p>
              <p style={styles.stepDescStyle}>{step.description}</p>
            </div>
            {index < CONNECTION_STEPS.length - 1 && (
              <div className="progress-line" style={styles.progressLineStyle}>
                <div
                  style={styles.progressLineActiveStyle(
                    connectionStep > step.step
                  )}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );

  // Render broker selection step
  const renderBrokerSelection = () => (
    <div style={styles.brokersGridStyle} className="brokers-grid row">
      {getFilteredBrokers().map((broker) => (
        <div
          key={broker.id}
          style={styles.brokerCardStyle}
          className="broker-card col-md-6 w-100"
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#3b82f6";
            e.currentTarget.style.boxShadow = "0 10px 25px -5px rgba(0, 0, 0, 0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#e5e7eb";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <div style={styles.brokerHeaderStyle} className="broker-header">
            <div style={styles.brokerInfoStyle} className="broker-info">
              <img
                src={broker.imgUrl}
                alt={broker.name}
                style={styles.brokerImageStyle}
              />
              <div>
                <h3 style={styles.brokerNameStyle}>{broker.name}</h3>
                <div style={styles.brokerMetaStyle} className="broker-meta">
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Settings
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "4px",
                      }}
                    />
                    {broker.difficulty}
                  </span>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Zap
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "4px",
                      }}
                    />
                    {broker.setupTime}
                  </span>
                </div>
              </div>
            </div>
            <div style={styles.statusBadgeStyle(broker.status)}>
              {broker.status === "active" ? "Available" : "Inactive"}
            </div>
          </div>

          <p style={styles.brokerDescStyle}>{broker.description}</p>

          <div style={styles.featuresGridStyle} className="features-grid">
            {broker?.features?.map((feature, index) => (
              <div key={index} style={styles.featureItemStyle}>
                <CheckCircle
                  style={{
                    width: "16px",
                    height: "16px",
                    color: "#10b981",
                    marginRight: "8px",
                  }}
                />
                {feature}
              </div>
            ))}
          </div>



          <div className="res1">

            <button
              className="btn btn-primary"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1d4ed8";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#2563eb";
              }}
              onClick={() => handleBrokerSelect(broker)}
            >
              <span className="text-white">Connect with {broker.name}</span>
              <ArrowRight style={{ width: "16px", height: "16px" }} />
            </button>


            <button
              className="btn btn-primary ms-2"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1d4ed8";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#2563eb";
              }}
              onClick={navigateToGuide}
            >
              <span className="text-white">View Process</span>
              <ArrowRight style={{ width: "16px", height: "16px" }} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );

  // Render API configuration step
  const renderApiConfiguration = () => (
    <div>
      <div style={styles.apiConfigContainerStyle}>
        <img
          src={selectedBroker.imgUrl}
          alt={selectedBroker.name}
          style={styles.brokerImageLargeStyle}
        />
        <h2 style={styles.sectionTitleStyle}>
          Configure {selectedBroker.name} API
        </h2>
        <p style={{ color: "#6b7280" }}>
          Enter your API credentials to establish connection
        </p>
      </div>

      <div style={styles.formContainerStyle}>
        <div style={styles.securityNoticeStyle}>
          <div style={styles.securityNoticeContentStyle}>
            <AlertCircle
              style={{
                width: "20px",
                height: "20px",
                color: "#2563eb",
                marginTop: "2px",
              }}
            />
            <div>
              <h4 style={styles.securityTitleStyle}>Security Notice</h4>
              <p style={styles.securityTextStyle}>
                Your API credentials are encrypted and stored securely. We
                recommend using API keys with limited permissions for trading only.
              </p>
            </div>
          </div>
        </div>

        {getBrokerFields()?.map((field, index) => (
          <div key={index} style={styles.formGroupStyle}>
            <label style={styles.labelStyle}>{field.label}</label>
            <input
              type={field.type}
              name={field.name}
              value={apiCredentials[field.name] || ""}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              placeholder={field.placeholder}
              style={styles.inputStyle}
              onFocus={(e) => {
                e.target.style.borderColor = "#3b82f6";
                e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        ))}

        <div style={styles.buttonGroupStyle} className="button-group">
          <button
            onClick={resetProcess}
            style={styles.backButtonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#d1d5db";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#e5e7eb";
            }}
          >
            Back
          </button>
          {userdetail?.TradingStatus == 0 && (<button
            onClick={handleApiSubmit}
            className="btn btn-primary"
            disabled={isConnecting}
          >
            <span className="text-white">
              {isConnecting ? "Connecting..." : "Test Connection"}
            </span>
            <ArrowRight style={{ width: "16px", height: "16px" }} />
          </button>)}
        </div>
      </div>
    </div>
  );

  // Render testing step
  const renderTesting = () => (
    <div style={styles.testConnectionStyle}>
      <div style={styles.testContainerStyle}>
        <div style={{ marginBottom: "24px" }}>
          <div style={styles.loadingSpinnerStyle} />
        </div>
        <h2 style={styles.sectionTitleStyle}>Testing Connection</h2>
        <p style={{ color: "#6b7280", marginBottom: "24px" }}>
          Please wait while we verify your API credentials and test the
          connection to {selectedBroker?.name}
        </p>
        <div style={styles.loadingTextStyle}>
          <div style={styles.loadingStatusStyle}>
            <div style={styles.pulseStyle} />
            <span>Verifying credentials...</span>
          </div>
        </div>
      </div>
    </div>
  );

  // Render success step
  const renderSuccess = () => (
    <div style={styles.successContainerStyle}>
      <div style={styles.testContainerStyle}>
        <div style={{ marginBottom: "24px" }}>
          <div style={styles.successIconContainerStyle}>
            <CheckCircle
              style={{ width: "40px", height: "40px", color: "#16a34a" }}
            />
          </div>
          <h2 style={styles.sectionTitleStyle}>Connection Successful!</h2>
          <p style={{ color: "#6b7280", marginBottom: "24px" }}>
            Your {selectedBroker?.name} account has been successfully connected
            and verified.
          </p>
        </div>

        <div style={styles.successStatusStyle}>
          {brokerId === "5" || brokerId === 5 ? "" :
            <div style={styles.statusRowStyle}>
              <span style={styles.statusLabelStyle}>
                {brokerId === "1" || brokerId === 1 ? "ID:" : "Client ID:"}
              </span>
              <span style={styles.statusValueStyle}>
                {brokerId === "1" || brokerId === 1
                  ? brokerdetail?.coindcx_id
                  : brokerdetail?.client_id || brokerdetail?.id}
              </span>
            </div>}
          <div style={styles.statusRowStyle}>
            <span style={styles.statusLabelStyle}>Name:</span>
            <span style={styles.statusValueStyle}>
              {brokerdetail?.first_name || user_details.FullName} {brokerdetail?.last_name}
            </span>
          </div>
          <div style={styles.statusRowStyle}>
            <span style={styles.statusLabelStyle}>Email:</span>
            <span style={styles.statusValueStyle}>
              {brokerdetail?.email || user_details.Email}
            </span>
          </div>
          <div style={styles.statusRowLastStyle}>
            <span style={styles.statusLabelStyle}>Mobile Number:</span>
            <span style={styles.statusValueStyle}>
              {brokerdetail?.mobile_number || brokerdetail?.phone_number || user_details.mobile}
            </span>
          </div>
        </div>

        <div style={styles.buttonGroupStyle} className="button-group">
          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => {
              navigate("/client/dashboard");
              window.location.reload();
            }}
          >
            <TrendingUp style={{ width: "16px", height: "16px" }} />
            <span className="text-white">Start Trading</span>
          </button>
        </div>
      </div>
    </div>
  );

  // Render error step
  const renderError = () => (
    <div style={styles.formContainerStyle || styles.successContainerStyle}>
      <div style={styles.testContainerStyle}>
        <div style={{ marginBottom: "24px" }}>
          <div style={styles.formContainerStyle || styles.successIconContainerStyle}>
            <XCircle style={{ width: "40px", height: "40px", color: "#ef4444" }} />
          </div>
          <h2 style={styles.sectionTitleStyle}>Connection Failed</h2>
          <p style={{ color: "#6b7280", marginBottom: "24px" }}>
            We couldn't establish a connection with {selectedBroker?.name}.
            Please check your credentials and try again.
          </p>
        </div>

        {errorMessage && (
          <div
            style={{
              padding: "16px",
              backgroundColor: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: "8px",
              marginBottom: "24px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <AlertCircle
                style={{ width: "20px", height: "20px", color: "#ef4444" }}
              />
              <span style={{ color: "#dc2626", fontWeight: "500" }}>
                Error Details:
              </span>
            </div>
            <p
              style={{
                color: "#991b1b",
                marginTop: "8px",
                marginBottom: "0",
              }}
            >
              {errorMessage}
            </p>
          </div>
        )}

        <div style={styles.buttonGroupStyle} className="button-group">
          <button
            onClick={resetProcess}
            style={styles.backButtonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#d1d5db";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#e5e7eb";
            }}
          >
            Start Over
          </button>
          <button
            onClick={retryConnection}
            className="btn btn-primary d-flex align-items-center gap-2"
          >
            <RefreshCw style={{ width: "16px", height: "16px" }} />
            <span className="text-white">Try Again</span>
          </button>
        </div>
      </div>
    </div>
  );



  const renderAccessDenied = () => (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2 style={{ color: "#ef4444" }}>Access Denied</h2>
      <p style={{ color: "#6b7280" }}>
        You do not have permission to connect a broker. Please contact your
        administrator for assistance.
      </p>
    </div>
  );



  if (!hasValidLicense()) {
    return <Content button_status={false}>{renderAccessDenied()}</Content>;
  }

  return (
    <Content button_status={false} Page_title="Connect Broker" Page_title_showClient="Seamlessly connect with your preferred trading broker to start
              automated trading">
      <div style={styles.containerStyle}>
        <style>{styles.responsiveStyles}</style>
        <div style={styles.maxWidthStyle}>


          {renderProgressSteps()}
        </div>

        <div className="broker-container" style={styles.mainContentStyle}>
          {connectionStep === 1 && renderBrokerSelection()}
          {connectionStep === 2 && selectedBroker && renderApiConfiguration()}
          {connectionStep === 3 && renderTesting()}
          {connectionStep === 4 && connectionStatus === "success" && renderSuccess()}
          {connectionStep === 4 && connectionStatus === "error" && renderError()}
        </div>
      </div>
    </Content>
  );
};

export default BrokerConnectPage;